import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { KeywordService } from '../services';

const useUpdateKeywordPriority = (keywordId: string) => {
  const { t } = useTranslation(['keyword', 'errors']);
  // const queryClient = useQueryClient();

  const { mutateAsync, isPending: isLoading, data } = useMutation(
    (status: string) => KeywordService.updatePriority(keywordId, status),
    {
      onSuccess: ({ data }: any) => {
        toast.success(t('keyword:prioritySuccessUpdate'));
      },
      onError: () => {
        toast.error(t('generalErrorMessage', { ns: 'errors' }));
      },
    },
  );

  return {
    updateStatus: mutateAsync,
    isLoading,
    value: data?.data?.visible,
  };
};

export default useUpdateKeywordPriority;
